export const ERROR = 'ERROR';
export const receiveError = (error) => ({
  type: ERROR,
  error,
});
